// assets/before-after.js
(function () {
  function initComparador(wrap) {
    if (wrap._baInit) return; // ya inicializado
    wrap._baInit = true;

    const before = wrap.querySelector('.ba-before');
    const handle = wrap.querySelector('.ba-handle');
    const range  = wrap.querySelector('.ba-range');

    if (!before || !handle || !range) {
      console.warn('BA: faltan elementos en wrap', wrap);
      return;
    }

    function setSplit(pct){
      pct = Math.max(0, Math.min(100, pct));
      before.style.clipPath = `inset(0 ${100 - pct}% 0 0)`;
      handle.style.left = pct + '%';
    }

    // inicial
    setSplit(50);

    // input
    range.addEventListener('input', e => setSplit(Number(e.target.value)));

    // pointer/mouse handlers con fallback
    const onPointerDown = function(e){
      // permitir drag aunque el theme capture pointers
      try { wrap.setPointerCapture && wrap.setPointerCapture(e.pointerId); } catch(err){}
      const move = ev => {
        const r = wrap.getBoundingClientRect();
        const pct = ((ev.clientX - r.left) / r.width) * 100;
        setSplit(pct);
      };
      const up = ()=> {
        wrap.removeEventListener('pointermove', move);
        wrap.removeEventListener('pointerup', up);
      };
      wrap.addEventListener('pointermove', move);
      wrap.addEventListener('pointerup', up);
    };

    // support pointer events if available
    wrap.addEventListener('pointerdown', onPointerDown);

    // fallback mouse/touch
    let dragging = false;
    const onMouseDown = e => { dragging = true; moveMouse(e); };
    const onMouseMove = e => { if (!dragging) return; moveMouse(e); };
    const onMouseUp = () => dragging = false;
    function moveMouse(ev){
      const r = wrap.getBoundingClientRect();
      const clientX = ev.touches ? ev.touches[0].clientX : ev.clientX;
      const pct = ((clientX - r.left) / r.width) * 100;
      setSplit(pct);
    }
    wrap.addEventListener('mousedown', onMouseDown);
    window.addEventListener('mousemove', onMouseMove);
    window.addEventListener('mouseup', onMouseUp);
    wrap.addEventListener('touchstart', onMouseDown, {passive:true});
    window.addEventListener('touchmove', onMouseMove, {passive:true});
    window.addEventListener('touchend', onMouseUp);
  }

  function initAll() {
    const wraps = document.querySelectorAll('.ba-wrap');
    if (!wraps.length) {
      // nada aún
      return;
    }
    wraps.forEach(initComparador);
  }

  // Cuando DOM cargue, intentar init
  document.addEventListener('DOMContentLoaded', function(){
    console.info('BA: DOMContentLoaded - intentando initAll');
    initAll();

    // Observer: puede que editor o theme inserten bloques después
    const observer = new MutationObserver((mutations) => {
      // buscar nuevos .ba-wrap
      const found = document.querySelectorAll('.ba-wrap:not([data-ba-observed])');
      if (found.length) {
        found.forEach(el => {
          el.setAttribute('data-ba-observed', '1');
          initComparador(el);
        });
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });

  // También intentar después de 1s y 3s por si carga asíncrona
  setTimeout(initAll, 1000);
  setTimeout(initAll, 3000);

})();
